import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import AdminLayout from './AdminLayout';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import *  as actionsCategories from '../category/redux/actions';
import { Modal, Button, Select, Row, Col, Icon, Collapse, List, Popconfirm } from 'antd';
import { Inputs } from '../../helper/form/input';
import _ from 'lodash';
const Panel = Collapse.Panel;

export class Categories extends Component {
  static propTypes = {
    admin: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    modal_visible: false,
    modal_number: -1, //new
    modal_category_name: '',
    modal_category_name_is_valid: false,
    modal_category_parent: null
  }

  Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  componentDidMount() {
    this.props.actions.getCategories('subs');
  }

  modal = () => {
    if (this.state.modal_visible) {
      const isParent = this.props.category.list.filter(c => c.id === this.state.modal_number).length > 0

      return (<Modal
        title={this.state.modal_number === -1 ? 'Ajouter une categorie' : 'Modifier une categorie'}
        style={{ top: 50 }}
        width={700}
        visible={this.state.modal_visible}
        onCancel={() => this.showModal(false, -1)}
        footer={[
          <Button key="back" onClick={() => this.showModal(false)}>
            <Icon type="delete" />
            ANNULER
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={!this.state.modal_category_name_is_valid}
            onClick={() => {
              this.state.modal_number === -1 ?
                this.props.actions.addCategory({ name: this.Capitalize(this.state.modal_category_name), parentCategory: this.state.modal_category_parent })
                  .then((res) => { this.showModal(false, -1) })
                :
                this.props.actions.setCategory(this.state.modal_number, { name: this.Capitalize(this.state.modal_category_name), parentCategory: this.state.modal_category_parent })
                  .then((res) => { this.showModal(false, -1) })
            }
            }>
            <Icon type={this.state.modal_number === -1 ? 'plus' : 'edit'} />
            {this.state.modal_number === -1 ? 'CRÉER' : 'MODIFIER'}
          </Button>,
        ]}
      >
        <Row>
          <Col xs={{ span: 24 }} md={{ span: isParent ? 24 : 14 }}>
            <Inputs.Item
              value={this.state.modal_category_name}
              placeholder="Nom"
              onCheck={(modal_category_name_is_valid) => this.setState({ modal_category_name_is_valid })}
              onChange={(modal_category_name) => this.setState({ modal_category_name })}
              isValid={(categorie) =>
                categorie.length >= 2
                && !this.props.category.list.map(c => c.name.toLowerCase()).includes(categorie.toLowerCase())
                && !this.props.category.list.some(c => c.subsCategories.map(s => s.name.toLowerCase()).includes(categorie.toLowerCase()))
              }
              status={{ success: '', error: 'La categorie doit être unique et faire plus de 2 caractères' }}
              checkOnChange
              checkOnBlur
              notEmpty
            />
          </Col>
          {!isParent ?
            <Col xs={{ span: 24 }} md={{ span: 8, offset: 1 }} style={{ padding: '4px 0 0 0' }}>
              <Select
                style={{ width: '100%' }}
                value={this.state.modal_category_parent}
                onChange={(e) => {
                  this.setState({ modal_category_parent: e })
                }}>
                { this.state.modal_number !== -1 && this.state.modal_category_parent > 0 ? '': <Select.Option value={0}>Aucune</Select.Option> }
                {
                  _.sortBy(this.props.category.list, ['name']).map(items => {
                    return <Select.Option value={items.id} key={items.id} >{items.name}</Select.Option>
                  })
                }
              </Select>
            </Col>
            : ''
          }
        </Row>
      </Modal>)
    } else return ''
  }

  showModal = (modal_visible, modal_number = this.state.modal_number, modal_category_name = null, modal_category_parent = 0) =>
    this.setState({ modal_visible, modal_number, modal_category_name, modal_category_parent, modal_category_name_is_valid: modal_number > 0 });

  render() {

    return (
      <AdminLayout
        title="CATEGORIES"
        buttons={
          [{
            onClick: () => this.showModal(true, -1),
            icon: "plus",
            name: "AJOUTER UNE CATEGORIE"
          }]
        }
      >
        <div className="category-component">
          <Collapse accordion style={{ marginTop: '30px' }}>
            {
              _.sortBy(this.props.category.list, ['name']).map(item => {
                const header = 
              <div style={{paddingRight: '15px'}}>
                <Row gutter={10}>
                 <Col xs={{ span: 12 }} sm={{ span: 16 }} md={{ span: 20 }}>
                    {item.name}
                  </Col>
                    <Col className="gutter-row" xs={{ span: 4 }} md={{ span: 2 }}>
                      <Button 
                      style={{ width: '100%' }} 
                      icon="edit"
                      size="small"
                      onClick= {() => this.showModal( true, item.id, item.name ) } 
                      ></Button>
                    </Col>
                    <Col className="gutter-row" xs={{ span: 4 }} md={{ span: 2 }}>
                    <Popconfirm 
                        title="Êtes-vous sûr de supprimer cette catégorie ?" 
                        onConfirm={ () => 
                          this.props.actions.deleteCategory( item.id )
                        }
                        okText="Oui" 
                        cancelText="Non">
                      <Button style={{ width: '100%' }} icon="delete" type="danger" size="small"></Button>
                      </Popconfirm>
                    </Col>
                  </Row>
                </div>

                return (<Panel header={header} key={item.id} disabled={(!item.subsCategories || !item.subsCategories.length > 0)}>
                  {
                    item && item.subsCategories && item.subsCategories.length > 0 ?
                      <List
                        dataSource={_.sortBy(item.subsCategories, ['name'])}
                        renderItem={data => (<List.Item style={{ paddingLeft: '25px' }}>
                          <Row style={{ width: '100%' }}>
                            <Col xs={{ span: 15 }} sm={{ span: 19 }} md={{ span: 21 }}>
                              {data.name}
                            </Col>
                            <Col xs={{ span: 8 }} sm={{ span: 4 }} md={{ span: 2 }}>
                              <Col xs={{ span: 12 }}>
                                <Button
                                  style={{ width: '100%' }}
                                  icon="edit"
                                  onClick={() => this.showModal(true, data.id, data.name, item.id)}
                                ></Button>
                              </Col>
                              <Col xs={{ span: 11, offset: 1 }}>
                                <Popconfirm
                                  title="Êtes-vous sûr de supprimer cette catégorie ?"
                                  onConfirm={() =>
                                    this.props.actions.deleteCategory(data.id, item.id)
                                  }
                                  okText="Oui"
                                  cancelText="Non">
                                  <Button
                                    style={{ width: '100%' }}
                                    icon="delete"
                                    type="danger"
                                  />
                                </Popconfirm>
                              </Col>
                            </Col>
                          </Row>
                        </List.Item>)}
                      />
                      : ''

                  }
                </Panel>)
              })
            }
          </Collapse>

          {this.modal()}
        </div>
      </AdminLayout>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    admin: state.admin,
    category: state.category
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...actionsCategories }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Categories);



// WEBPACK FOOTER //
// ./src/features/admin/Categories.js